<template>
  <div>
    <SchoolBanner :imageList="this.config.banner_top.imageList"></SchoolBanner>
    <SchoolTitle></SchoolTitle>
    <SchoolIntroduction></SchoolIntroduction>
    <SchoolJob></SchoolJob>
    <SchoolCards></SchoolCards>
    <SchoolTitle2></SchoolTitle2>
    <SchoolCard2></SchoolCard2>
    <SchoolCard3></SchoolCard3>
    <SchoolProcess></SchoolProcess>
    <SchoolRecruitment></SchoolRecruitment>
    <SchoolSecret></SchoolSecret>
    <SchoolBanner3></SchoolBanner3>
  </div>
</template>

<script>
import SchoolBanner from "@/yintai/view/content/school/SchoolBanner.vue";
import SchoolTitle from "@/yintai/view/content/school/SchoolTitle.vue";
import SchoolIntroduction from "@/yintai/view/content/school/SchoolIntroduction.vue";
import SchoolJob from "@/yintai/view/content/school/SchoolJob.vue";
import SchoolCards from "@/yintai/view/content/school/SchoolCards.vue";
import SchoolTitle2 from "@/yintai/view/content/school/SchoolTitle2.vue";
import SchoolCard2 from "@/yintai/view/content/school/SchoolCard2.vue";
import SchoolCard3 from "@/yintai/view/content/school/SchoolCard3.vue";

import SchoolProcess from "@/yintai/view/content/school/SchoolProcess.vue";
import SchoolRecruitment from "@/yintai/view/content/school/SchoolRecruitment.vue";
import SchoolSecret from "@/yintai/view/content/school/SchoolSecret.vue";

import SchoolBanner3 from "@/yintai/view/content/school/SchoolBanner3.vue";
import { fetchConfig } from "@/yintai/api/config";

export default {
  name: "school",
  components: {
    SchoolBanner,
    SchoolTitle,
    SchoolIntroduction,
    SchoolJob,
    SchoolCards,
    SchoolTitle2,
    SchoolCard2,
    SchoolCard3,
    SchoolProcess,
    SchoolRecruitment,
    SchoolSecret,
    SchoolBanner3,
  },
  metaInfo() {
    return {
      meta: [{name: "keywords" ,content:"银泰百货校招,银泰百货校园招聘,银泰招聘,银泰百货招聘"},{name:"description",content:"银泰百货面向全国高校招聘，银泰百货300+职位等待优秀的大学毕业生应聘，参与银泰招聘，成为业界领先的新零售解决方案缔造者！"}],
      title: "银泰百货校招-银泰百货校园招聘-银泰招聘"
    };
  },
  data() {
    return {
      config: {
        banner_top: {
          imageList: [],
        },
      },
    };
  },
  async mounted() {
    const response = await fetchConfig({ id: 12 });
    this.config = response.data.data.item.config;
  },
  methods: {},
};
</script>
